export default __webpack_public_path__ + "static/media/clown.cd0f5f7e.png";